// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_lq-0";
export var discountCodeInput = "_lq-1";